import React, { useEffect } from "react";
// import { Box } from "@material-ui/core";
import Box from '@mui/material/Box';
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import BackgroundTheme from "../../../../Common/P2P/Header/BackgroundTheme";
import PersonalDetailsForm from "./personalDetailsForm";
import { ckycConfirmReq, getResetIfscCode } from "../../ConnectBank/connectBankAction";

const PersonalInfoDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {ckycConfirmData, connectFetchKycData, ckycConfirmError } = useSelector(
    (state: any) => state.connectBank
  );

  useEffect(() => {
    if (ckycConfirmData && ckycConfirmData?.status) {
      history.push({pathname:"/p2p/lenderAgreement"});
      dispatch(getResetIfscCode())
    }
  }, [ckycConfirmData])

  const handleAccept = () => {
    dispatch(ckycConfirmReq())
  };

  return (
    <>
      <BackgroundTheme>
        <Box className="personalInfo">
          <PersonalDetailsForm
            ckycDetails={connectFetchKycData}
            handleAccept={handleAccept}
            ckycConfirmError={ckycConfirmError}
          />
        </Box>
      </BackgroundTheme>
    </>
  );
};
export default PersonalInfoDetails;